<template>
  <div class="analytics-page fade-in">
    <!-- ===== Header ===== -->
    <div class="header-row">
      <h1 class="page-title">
        <i class="bx bx-globe"></i> {{ selectedWebsite || "Select Website" }}
      </h1>
      <div class="filters">
        <select v-model="selectedWebsite" class="select-theme">
          <option disabled value="">-- Select Website --</option>
          <option>analytcly.ai</option>
          <option>plumberpro.ai</option>
          <option>dentalai.com</option>
        </select>
        <select v-model="selectedRange" class="select-theme">
          <option>Today</option>
          <option>Last 7 Days</option>
          <option>Last 30 Days</option>
          <option>Last 12 Months</option>
        </select>
        <button class="btn-primary"><i class="bx bx-search"></i> Search</button>
      </div>
    </div>

    <!-- ===== KPI Cards ===== -->
    <div class="kpi-row fade-in">
      <div class="kpi-card" v-for="(kpi, i) in kpis" :key="i">
        <div>
          <h4>{{ kpi.label }}</h4>
          <div class="value">{{ kpi.value }}</div>
        </div>
        <i :class="kpi.icon + ' kpi-icon'"></i>
      </div>
    </div>

    <div class="cta-card" @click="goToAnalytics">
      <div class="cta-content">
        <div class="cta-text">
          <h2>📊 Unlock the Power of Your Business Data</h2>
          <p>
            Visualize, understand, and grow with AI-powered analytics.  
            Discover where your visitors come from, what drives results,  
            and how your business can perform even better — all in real time.
          </p>
        </div>

        <div class="cta-action">
          <button class="cta-btn">
            <i class="bx bx-line-chart"></i>
            Explore Analytics
          </button>
        </div>
      </div>
    </div>

    <!-- ===== AI Banner ===== -->
    

    <!-- ===== Analytics Grid ===== -->
    <div class="analytics-grid">
      <!-- Left -->
      <div class="left-grid">
        <div class="chart-card fade-in">
          <h4>Your Website Progress</h4>
          <div id="progressChart" class="chart"></div>
        </div>

        <div class="chart-card fade-in" style="margin-top: 1rem;">
          <h4>Sources Report</h4>
          <div id="sourcesChart" class="chart"></div>
        </div>

        <div class="chart-card fade-in" style="margin-top: 1rem;">
          <h4>Users By Country</h4>
          <div id="mapdiv" class="mapchart"></div>
        </div>
      </div>

      <!-- Right -->
      <div class="right-grid">
        <div class="realtime-card fade-in">
          <div class="realtime-header">
            <i class="bx bx-pulse"></i>
            <h4 style="color: #fff;">Realtime Visitors</h4>
          </div>
          <div class="realtime-value">{{ realtimeVisitors }}</div>
          <p class="text-muted" style="color: #fff;">Currently active on your websites</p>
        </div>

        <div class="card fade-in" style="margin-top: 1rem;">
          <h4>Top Referrers</h4>
          <ul>
            <li v-for="(ref, i) in referrers" :key="i">
              <span><i class="bx bx-link"></i> {{ ref.name }}</span>
              <span class="count">{{ ref.count }}</span>
            </li>
          </ul>
        </div>

        <div class="chart-card fade-in" style="margin-top: 1rem;">
          <h4>Users by Device</h4>
          <div id="deviceChart" class="chart"></div>
        </div>

        <div class="chart-card fade-in" style="margin-top: 1rem;">
          <h4>Conversion Funnel</h4>
          <div id="funnelChart" class="chart"></div>
        </div>
      </div>
    </div>
    <br><br><br>
  </div>
</template>

<script>
import ApexCharts from "apexcharts";
import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import am5geodata_worldLow from "@amcharts/amcharts5-geodata/worldLow";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

export default {
  name: "AnalyticsPage",
  data() {
    return {
      selectedWebsite: "analytcly.ai",
      selectedRange: "Last 30 Days",
      realtimeVisitors: 12,
      kpis: [
        { label: "Unique Visitors", value: "589", icon: "bx bx-user" },
        { label: "Total Visits", value: "2,340", icon: "bx bx-show" },
        { label: "Total Pageviews", value: "4,612", icon: "bx bx-bar-chart-alt" },
        { label: "Views Per Visit", value: "2.3", icon: "bx bx-line-chart" },
        { label: "Bounce Rate", value: "12%", icon: "bx bx-trending-down" },
        { label: "Visit Duration", value: "1m 45s", icon: "bx bx-timer" },
      ],
      referrers: [
        { name: "Direct / None", count: 124 },
        { name: "Google", count: 85 },
        { name: "Facebook", count: 43 },
        { name: "LinkedIn", count: 27 },
      ],
      countries: [
        { id: "US", name: "United States", visitors: 400 },
        { id: "IN", name: "India", visitors: 320 },
        { id: "GB", name: "United Kingdom", visitors: 210 },
        { id: "DE", name: "Germany", visitors: 160 },
        { id: "CA", name: "Canada", visitors: 140 },
      ],
    };
  },
  mounted() {
    this.renderCharts();
    this.renderMap();
  },
  methods: {
    renderCharts() {
      document.querySelectorAll(".apexcharts-canvas").forEach((el) => el.remove());

      // Website Progress (Line Chart)
      new ApexCharts(document.querySelector("#progressChart"), {
        chart: { type: "line", height: 250, toolbar: { show: false } },
        series: [{ name: "Visitors", data: [10, 30, 25, 40, 60, 45, 70] }],
        xaxis: { categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] },
        stroke: { curve: "smooth", width: 3 },
        colors: ["#111827"],
        fill: {
          type: "gradient",
          gradient: { shadeIntensity: 1, opacityFrom: 1, opacityTo: 1 },
        },
        grid: { borderColor: "#f3f4f6" },
      }).render();

      // Sources Report
      new ApexCharts(document.querySelector("#sourcesChart"), {
        chart: { type: "bar", height: 250, toolbar: { show: false } },
        series: [{ name: "Visits", data: [100, 80, 60, 40, 25] }],
        xaxis: { categories: ["Direct", "Google", "Facebook", "LinkedIn", "Email"] },
        colors: ["#1f2937"],
      }).render();

      // Device Chart (Dashboard Style)
      new ApexCharts(document.querySelector("#deviceChart"), {
        chart: { type: "donut", height: 250 },
        series: [60, 25, 15],
        labels: ["Desktop", "Mobile", "Tablet"],
        colors: ["#111827", "#4b5563", "#9ca3af"],
        legend: { position: "bottom" },
        dataLabels: { enabled: false },
        stroke: { width: 0 },
      }).render();

      // Funnel (Black Shades)
      new ApexCharts(document.querySelector("#funnelChart"), {
        chart: { type: "bar", height: 250, toolbar: { show: false } },
        plotOptions: { bar: { horizontal: true, borderRadius: 6 } },
        series: [{ name: "Conversions", data: [300, 180, 90] }],
        xaxis: { categories: ["Visitors", "Leads", "Conversions"] },
        colors: ["#111827", "#4b5563", "#9ca3af"],
        grid: { borderColor: "#e5e7eb" },
      }).render();
    },

    renderMap() {
      am5.ready(() => {
        const root = am5.Root.new("mapdiv");
        root.setThemes([am5themes_Animated.new(root)]);

        const chart = root.container.children.push(
          am5map.MapChart.new(root, { projection: am5map.geoMercator() })
        );

        const polygonSeries = chart.series.push(
          am5map.MapPolygonSeries.new(root, { geoJSON: am5geodata_worldLow })
        );

        const visitorMap = {};
        this.countries.forEach((c) => (visitorMap[c.id] = c.visitors));

        const max = Math.max(...Object.values(visitorMap));
        const minColor = am5.color(0x000000);
        const maxColor = am5.color(0x000000);

        polygonSeries.mapPolygons.template.setAll({
          tooltipText: "{name}: {value}",
          interactive: true,
        });

        polygonSeries.data.setAll(
          this.countries.map((c) => ({
            id: c.id,
            name: c.name,
            value: c.visitors,
          }))
        );

        polygonSeries.mapPolygons.template.adapters.add("fill", (fill, target) => {
          const id = target.dataItem?.dataContext?.id;
          const value = visitorMap[id];
          if (value) {
            const ratio = value / max;
            return am5.Color.interpolate(minColor, maxColor, ratio);
          }
          return am5.color(0xf3f4f6);
        });
      });
    },
  },
};
</script>

<style scoped>
.fade-in { animation: fadeInUp 0.5s ease forwards; opacity: 0; transform: translateY(10px); }
@keyframes fadeInUp { to { opacity: 1; transform: translateY(0); } }

.header-row { display: flex; justify-content: space-between; flex-wrap: wrap; gap: 12px; margin-bottom: 20px; }
.page-title { font-size: 1.2rem; font-weight: 600; color: var(--text); display: flex; align-items: center; gap: 8px; }
.filters { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.select-theme { padding: 8px 12px; border: 1px solid var(--border); border-radius: 8px; font-size: 13px; color: var(--muted); }
.btn-primary { background: var(--primary); color: #fff; border: none; border-radius: 8px; padding: 8px 16px; font-size: 13px; }
.btn-primary:hover { background: var(--primary-dark); }

/* === KPI Cards === */
.kpi-row { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 16px; margin-bottom: 24px; }
.kpi-card {
  background: #fff;
  color: #111827;
  border-radius: 10px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--border);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.kpi-card h4 { font-size: 13px; color: #6b7280; }
.kpi-card .value { font-size: 20px; font-weight: 700; color: #111827; }
.kpi-icon { font-size: 1.6rem; color: #9ca3af; }

/* === AI Banner === */
.ai-banner {
  background: linear-gradient(135deg, #111827, #1f2937);
  color: #fff;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.btn-gradient { background: #fff; color: #111827; border: none; border-radius: 8px; padding: 8px 16px; font-weight: 600; }
.banner-img { width: 320px; height: auto; border-radius: 8px; }

/* === Analytics Grid === */
.analytics-grid { display: grid; grid-template-columns: 70% 28%; gap: 20px; }
.chart-card, .card, .realtime-card { background: #fff; border: 1px solid var(--border); border-radius: 10px; padding: 16px; box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05); }

/* === Charts === */
.chart { height: 250px; width: 100%; }
.mapchart { height: 300px; width: 100%; }

/* === Realtime Visitors === */
.realtime-card { text-align: center; background: linear-gradient(135deg, #111827, #1f2937, #374151); color: #fff;}
.realtime-header { display: flex; align-items: center; justify-content: center; gap: 6px; font-weight: 600; color: #fff; }
.realtime-value { font-size: 2.5rem; font-weight: 700; color: #fff; margin: 8px 0; }
.text-muted { color: #6b7280; font-size: 13px; }

/* === Referrers === */
.card ul { list-style: none; padding: 0; }
.card li { display: flex; justify-content: space-between; border-bottom: 1px dashed var(--border); padding: 6px 0; font-size: 13px; }
.count { font-weight: 600; color: #111827; }

/* === Call to Action (CTA) Card === */
.cta-card {
  grid-column: span 12 / span 12;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  background: linear-gradient(135deg, #111827, #1f2937, #374151);
  position: relative;
  padding: 2rem 2.5rem;
  margin-bottom: 1.5rem;
  color: #f9fafb;
  cursor: pointer;
  transition: all 0.4s ease;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
}

.cta-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at top left, rgba(255, 255, 255, 0.1), transparent 70%);
  z-index: 0;
  opacity: 0.4;
  transition: opacity 0.3s ease;
}

.cta-card:hover::before {
  opacity: 0.6;
}

.cta-content {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.cta-text h2 {
  font-size: 1.6rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 0.5rem;
  letter-spacing: 0.3px;
}

.cta-text p {
  color: #d1d5db;
  font-size: 0.95rem;
  max-width: 540px;
  line-height: 1.6;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  color: #111827;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.15);
}

.cta-btn i {
  font-size: 1.2rem;
  transition: transform 0.3s ease;
}

.cta-btn:hover {
  background: #f3f4f6;
  transform: translateY(-2px);
}

.cta-btn:hover i {
  transform: translateX(4px);
}

/* === Hover Animation (Card) === */
.cta-card:hover {
  transform: translateY(-4px) scale(1.01);
  box-shadow: 0 14px 35px rgba(17, 24, 39, 0.4);
}

/* === Responsive === */
@media (max-width: 768px) {
  .cta-content {
    flex-direction: column;
    text-align: center;
  }

  .cta-text p {
    max-width: 100%;
  }
}

</style>
